// Generate a secure random user ID with crypto API
function generateUserId() {
  try {
    // Use crypto.getRandomValues for better security if available
    if (window.crypto && window.crypto.getRandomValues) {
      const array = new Uint8Array(24); // 24 bytes = 192 bits of entropy
      window.crypto.getRandomValues(array);
      return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
    }
  } catch (error) {
    console.warn('Crypto API not available, falling back to Math.random');
  }
  
  // Fallback to improved random generation
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  
  for (let i = 0; i < 24; i++) { // Increased length for better security
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return result;
}

// Session expiration: 24 hours
const SESSION_EXPIRY_HOURS = 24;

// Get or create user ID from localStorage with session management
export function getUserId() {
  const sessionData = localStorage.getItem('fileshare_session');
  
  try {
    if (sessionData) {
      const parsed = JSON.parse(sessionData);
      const now = Date.now();
      const expiryTime = parsed.timestamp + (SESSION_EXPIRY_HOURS * 60 * 60 * 1000);
      
      // Check if session is still valid
      if (now < expiryTime && parsed.userId) {
        return parsed.userId;
      }
    }
  } catch (error) {
    console.warn('Invalid session data, creating new session');
  }
  
  // Create new session
  const userId = generateUserId();
  const sessionData_new = {
    userId: userId,
    timestamp: Date.now(),
    securityFlag: 'private_session'
  };
  
  localStorage.setItem('fileshare_session', JSON.stringify(sessionData_new));
  // Keep legacy support
  localStorage.setItem('fileshare_user_id', userId);
  
  return userId;
}

// Store uploaded folder info
export function addUploadedFolder(folderData) {
  const folders = getUploadedFolders();
  folders.unshift(folderData); // Add to beginning
  
  // Keep only last 50 uploads
  if (folders.length > 50) {
    folders.splice(50);
  }
  
  localStorage.setItem('fileshare_folders', JSON.stringify(folders));
}

// Get list of uploaded folders
export function getUploadedFolders() {
  try {
    const folders = localStorage.getItem('fileshare_folders');
    return folders ? JSON.parse(folders) : [];
  } catch (error) {
    console.error('Error parsing uploaded folders:', error);
    return [];
  }
}

// Clear all stored data
export function clearStoredData() {
  localStorage.removeItem('fileshare_user_id');
  localStorage.removeItem('fileshare_folders');
  localStorage.removeItem('fileshare_session');
}

// Clear cached folder data (for refreshing folder names)
export function clearFolderCache() {
  localStorage.removeItem('fileshare_folders');
  console.log('Folder cache cleared');
}

// Copy text to clipboard
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    // Fallback for older browsers
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (fallbackError) {
      console.error('Failed to copy to clipboard:', fallbackError);
      return false;
    }
  }
} 